// extracted by mini-css-extract-plugin
export default {"add-status":"AddStatus_add-status__bf+W-","add-status-header":"AddStatus_add-status-header__KOvsr"};